// components/ConfirmModal.tsx
import { Modal, Button } from "components";

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  children?: React.ReactNode; // isi modal bisa custom
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmModal({
  isOpen,
  title = "Confirmation",
  children,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} closeModal={onCancel} isdarktitle title={title}>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer className="flex justify-end gap-3">
        <Button onClick={onCancel}>{cancelText}</Button>
        <Button color="primary" onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}